export function buildSearchTermUrl({ searchSubmitLink, searchTerm }) {
    return `${searchSubmitLink}?searchString=${encodeURIComponent(searchTerm)}`;
}